import {debounce} from '../Utility/DebounceUtility';

export class SearchSuggest {
  private readonly suggestInput: HTMLInputElement | null;
  private readonly searchPageUrl: string = '';
  private readonly url: string = '';
  private readonly core: string = '';
  private suggestList: HTMLElement | null;
  private suggestOverlay: HTMLElement | null;
  private currentValue: string = '';

  constructor() {
    this.suggestInput = document.querySelector('.js-suggest');
    this.suggestList = document.querySelector('.js-suggestList');
    this.suggestOverlay = document.querySelector('.js-searchOverlay');

    if (this.suggestInput === null) {
      return;
    } else {
      this.searchPageUrl = this.suggestInput.dataset.resultpage || '';
      this.core = this.suggestInput.dataset.core || '';
      this.url = this.suggestInput.dataset.url || '';
      this.initializeListeners();
      this.addSearchSubmitListener();
      this.initSuggestOverlay();
    }
  }

  public async triggerSearchRequest(suggestInput, suggestList) {
    this.emptySearchList(suggestInput, suggestList);
    if (suggestInput) {
      this.currentValue = suggestInput.value;
      const result = await this.getSearchResult(suggestInput.value);
      this.addSearchSuggestions(result, suggestList);
      if (result) {
       suggestInput.addEventListener('focus', () => {
          this.showSearchSuggest(suggestList);
        });
       this.showSearchSuggest(suggestList);
      }
    }
  }

  private initializeListeners() {
    if (this.suggestInput) {
      // @ts-ignore
      this.suggestInput.addEventListener('keyup', debounce(
        (event) => {
          if (this.suggestInput) {
            // @ts-ignore
            const suggestList = this.suggestInput.closest('div').querySelector('.js-suggestList');
            if (this.suggestInput.value.length === 0) {
              this.emptySearchList(this.suggestInput, suggestList) ;
            }
            if (!this.suggestInput || this.suggestInput.value === this.currentValue || this.suggestInput.value.length < 2) {
              return;
            }

            this.triggerSearchRequest(this.suggestInput, suggestList );
          }
        },
        300));

      this.suggestInput.addEventListener('input', (event) => {
        if (this.suggestInput) {
          if (this.suggestInput.value.length === 0) {
            // @ts-ignore
            const suggestList = this.suggestInput.closest('div').querySelector('.js-suggestList');
            this.emptySearchList(this.suggestInput, suggestList);
          }
        }
      });
    }
  }

  private async getSearchResult(query: string) {
    const response = await fetch(`${this.url}?core=${this.core}&query=${query}`, {
      method: 'get',
    });

    if ((response.status >= 200 && response.status < 300) && !response.redirected) {
      return await response.json();
    }

    return {};
  }

  private addSearchSuggestions(result, suggestList) {
    const keys = Object.keys(result);
    keys.forEach((searchTerm, index) => {
      const li = document.createElement('li');
      li.classList.add('search__form-autocomplete-item');
      const anchor = document.createElement('a');
      anchor.href = `${this.searchPageUrl}?query=${searchTerm}`;
      anchor.innerHTML = `${searchTerm}<span class="search__form-autocomplete-item-link-count">${result[searchTerm]}</span>`;
      anchor.classList.add('search__form-autocomplete-item-link');
      li.appendChild(anchor);
      if (suggestList) {
        suggestList.appendChild(li);
      }
    });
  }

  private emptySearchList(suggestInput, suggestList) {
    if (suggestInput) {
      suggestInput.removeEventListener('focus', () => {
        this.showSearchSuggest(suggestList);
      });
    }
    if (suggestList) {
      this.hideSearchSuggest(suggestList);
      while (suggestList.firstChild) {
        suggestList.removeChild(suggestList.firstChild);
      }
    }
  }

  private addSearchSubmitListener() {
    const searchForm: HTMLFormElement | null = document.querySelector('.js-searchForm');
    if (searchForm) {
      searchForm.addEventListener('submit', (e) => {
        e.preventDefault();

        if (this.suggestInput && this.searchPageUrl) {
          const newLink = this.searchPageUrl + '?query=' + this.suggestInput.value.toString();
          window.location.assign(newLink);
        }
      });
    }
  }

  private initSuggestOverlay() {
    const closeSearchButton = document.querySelector('.header-search__close');
    if (closeSearchButton) {
      closeSearchButton.addEventListener('click', () => {
        this.hideSearchSuggest(this.suggestList);
      });
    }

    if (this.suggestOverlay) {
      this.suggestOverlay.addEventListener('click', () => {
        this.hideSearchSuggest(this.suggestList);
      });
    }

    document.body.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.hideSearchSuggest(this.suggestList);
      }
    });
  }

  private showSearchSuggest(suggestList) {
    if (suggestList.classList.contains('js-suggestList')) {
      if (this.suggestOverlay) {
        this.suggestOverlay.classList.remove('hide');
      }
    }
    if (suggestList) {
      suggestList.classList.remove('hide');
    }
  }

  private hideSearchSuggest(suggestList) {
    if (suggestList.classList.contains('js-suggestList')) {
      if (this.suggestOverlay) {
        this.suggestOverlay.classList.add('hide');
      }
    }
    if (suggestList) {
      suggestList.classList.add('hide');
    }
  }
}
